<template>
  <div class="table-responsive">
    <table class="table bg-white table-sm table-striped table-middle fs-sm">
      <thead>
        <tr>
          <th v-if="$root.user.isAdmin" class="th-shrink" />
          <th class="text-right">Sériové číslo elektromera</th>
          <th class="text-right">Materiálové číslo</th>
          <th class="text-right">Koeficient zúčtovania</th>
          <th class="text-right">Dátum od</th>
          <th class="text-right">Dátum do</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id">
          <td v-if="$root.user.isAdmin" class="th-shrink">
            <b-dropdown variant="link" no-caret class="btn-p-0">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item @click.prevent="edit(item.id)">
                <b-icon icon="pencil-square" class="mr-1" />Upraviť
              </b-dropdown-item>
              <b-dropdown-item
                class="text-danger"
                @click.prevent="remove(item.id)"
              >
                <b-icon icon="trash" class="mr-1" />Vymazať
              </b-dropdown-item>
            </b-dropdown>
          </td>
          <td class="text-right">
            <template v-if="item.serialNumber">
              {{ item.serialNumber }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.serialNumber">
              {{ item.materialNumber }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.totalCoef">
              {{ item.totalCoef | formatNumber(2) }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.dateFrom">
              {{ item.dateFrom | formatDate }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.dateTo">
              {{ item.dateTo | formatDate }}
            </template>
            <template v-else> - </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    energetic: Object,
  },
  methods: {
    edit(id) {
      this.$parent.$parent.$refs.deviceForm.id = id
      this.$parent.$parent.add({ type: 'power', edit: true })
    },
    remove(id) {
      this.$parent.$parent.remove(id)
    },
  },
}
</script>
